import { Link } from 'react-router-dom';
import services from './servicesData';
import logo from './images/hero.png';
import './HomePage.css';

function HomePage() {
  return (
    <div className="home-container">
      <img src={logo} alt="Hero" className="home-image" />

<div className="home-content">
  <div className="home-description">
    We’re a family-run service business helping families during major life transitions like downsizing or moving. We offer hands-on support to sort, organize, and clean out properties, including planning and hosting on-site sales. From start to finish, we help you prepare the home for its next chapter—efficiently and compassionately.
  </div>

  <h3 className="home-section-title">What We Do</h3>
  <ul className="home-services">
    {services.map((service) => (
      <li key={service.id} className="service-item">
        <Link to={`/services/${service.id}`} className="service-link">
          <img src={service.icon} alt={`${service.title} icon`} className="service-icon" />
          <div className="service-text">
            <span className="service-name">{service.title}</span>
            <div className="service-description">{service.description}</div>
          </div>
        </Link>
      </li>
    ))}
  </ul>
</div>


    </div>
  );
}

export default HomePage;
